import axios from 'axios'
import { CALL_API } from 'tr-components/redux/CallApiMiddlewareActionCreator'
import { fetchOptions } from '../../../config/endpoints'

import equals from 'ramda/src/equals'
import { isUUID } from '../utils/validations'

import {
  formatAssignments,
  getKey,
  getUrl,
  messages,
  processSelections,
  sortKeys
} from './assign-helpers'

const BULK_SELECT_ALL = 'assign/BULK_SELECT_ALL'

const DELETE_ASSIGNMENT = 'assign/DELETE_ASSIGNMENT'
const DELETE_ASSIGNMENT_SUCCESS = 'assign/DELETE_ASSIGNMENT_SUCCESS'
const DELETE_ASSIGNMENT_FAIL = 'assign/DELETE_ASSIGNMENT_FAIL'

const DELETE_ASSIGNMENTS = 'assign/DELETE_ASSIGNMENTS'
const DELETE_ASSIGNMENTS_SUCCESS = 'assign/DELETE_ASSIGNMENTS_SUCCESS'
const DELETE_ASSIGNMENTS_FAIL = 'assign/DELETE_ASSIGNMENTS_FAIL'

const DOWNLOAD_FOR_CSV = 'assign/DOWNLOAD_FOR_CSV'
const DOWNLOAD_FOR_CSV_SUCCESS = 'assign/DOWNLOAD_FOR_CSV_SUCCESS'
const DOWNLOAD_FOR_CSV_FAIL = 'assign/DOWNLOAD_FOR_CSV_FAIL'

const GET_ASSIGNMENTS = 'assign/GET_ASSIGNMENTS'
const GET_ASSIGNMENTS_SUCCESS = 'assign/GET_ASSIGNMENTS_SUCCESS'
const GET_ASSIGNMENTS_FAIL = 'assign/GET_ASSIGNMENTS_FAIL'

const RESET_STATE = 'assign/RESET_STATE'

const UPDATE_ASSIGNMENT = 'assign/UPDATE_ASSIGNMENT'
const UPDATE_ASSIGNMENT_SUCCESS = 'assign/UPDATE_ASSIGNMENT_SUCCESS'
const UPDATE_ASSIGNMENT_FAIL = 'assign/UPDATE_ASSIGNMENT_FAIL'

const UPDATE_BULK_SELECTIONS = 'assign/UPDATE_BULK_SELECTIONS'

const UPDATE_PAGE_SIZE = 'assign/UPDATE_PAGE_SIZE'

export const actions = {
  BULK_SELECT_ALL,
  DELETE_ASSIGNMENT,
  DELETE_ASSIGNMENT_SUCCESS,
  DELETE_ASSIGNMENT_FAIL,
  DELETE_ASSIGNMENTS,
  DELETE_ASSIGNMENTS_SUCCESS,
  DELETE_ASSIGNMENTS_FAIL,
  DOWNLOAD_FOR_CSV,
  DOWNLOAD_FOR_CSV_SUCCESS,
  DOWNLOAD_FOR_CSV_FAIL,
  GET_ASSIGNMENTS,
  GET_ASSIGNMENTS_SUCCESS,
  GET_ASSIGNMENTS_FAIL,
  RESET_STATE,
  UPDATE_ASSIGNMENT,
  UPDATE_ASSIGNMENT_SUCCESS,
  UPDATE_ASSIGNMENT_FAIL,
  UPDATE_BULK_SELECTIONS,
  UPDATE_PAGE_SIZE
}

const pageSizeOptions = [25, 50, 100]

export const initialState = {
  assignments: [],
  bulkSelections: [],
  csvList: [],
  deleteList: [],
  filter: {
    brand: null,
    state: null
  },
  loader: {
    currentPage: 1,
    pageSize: pageSizeOptions[0],
    total: 0
  },
  loading: {
    downloadCsv: false,
    init: false,
    main: false,
    assignByStatus: false
  },
  messages,
  pageSizeOptions,
  searchText: null,
  sortStatus: {
    ascending: true,
    dataKey: 'positionName',
    key: 'position'
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case BULK_SELECT_ALL:
      const { assignments, bulkSelections } = state
      const allItems = assignments.map((x) => x.id)
      return {
        ...state,
        bulkSelections: equals(allItems, bulkSelections) ? [] : allItems
      }

    case DELETE_ASSIGNMENT:
      return {
        ...state,
        deleteList: [action.payload.deleteId]
      }

    case DELETE_ASSIGNMENT_SUCCESS:
      const { locationId: lid, positionId: pid } = action.requestPayload
      const matchesIds = ({ locationId, positionId }) => locationId !== lid || positionId !== pid
      return {
        ...state,
        assignments: state.assignments.filter(matchesIds),
        deleteList: [],
        loader: {
          ...state.loader,
          total: state.loader.total - 1
        }
      }
    case DELETE_ASSIGNMENT_FAIL:
      return {
        ...state
      }

    case DELETE_ASSIGNMENTS:
      const deleteList =
        action.payload.deleteType === 'all'
          ? state.assignments.map((x) => x.id)
          : action.payload.deleteItems
      return {
        ...state,
        deleteList: deleteList
      }
    case DELETE_ASSIGNMENTS_SUCCESS:
      const {
        requestPayload: { deleteItems, deleteType }
      } = action
      const newAssigns =
        deleteType === 'all' ? [] : state.assignments.filter((x) => !deleteItems.includes(x.id))

      const newTotal =
        deleteType === 'all' ? 0 : Object.assign({}, state.loader).total - deleteItems.length

      return {
        ...state,
        assignments: newAssigns,
        deleteList: [],
        bulkSelections: [],
        loader: {
          ...state.loader,
          total: newTotal
        }
      }
    case DELETE_ASSIGNMENTS_FAIL:
      return {
        ...state
      }

    case DOWNLOAD_FOR_CSV:
      return {
        ...state,
        loading: {
          ...state.loading,
          downloadCsv: true
        }
      }
    case DOWNLOAD_FOR_CSV_SUCCESS:
      return {
        ...state,
        csvList: formatAssignments(action.payload.assignments),
        loading: {
          ...state.loading,
          downloadCsv: false
        }
      }
    case DOWNLOAD_FOR_CSV_FAIL:
      return {
        ...state,
        loading: {
          ...state.loading,
          downloadCsv: false
        }
      }

    case GET_ASSIGNMENTS:
      const thisAction = action.payload.action
      return {
        ...state,
        bulkSelections: initialState.bulkSelections,
        filter: action.payload.filter,
        loader: {
          ...state.loader,
          currentPage: action.payload.currentPage,
          pageSize: action.payload.pageSize
        },
        loading: {
          ...state.loading,
          downloadCsv: thisAction === 'downloadCsv',
          init: thisAction === 'init',
          main: thisAction !== 'downloadCsv'
        },
        searchText: action.payload.searchText,
        sortStatus: action.payload.sortStatus
      }
    case GET_ASSIGNMENTS_SUCCESS:
      return {
        ...state,
        assignments: formatAssignments(action.payload.assignments),
        bulkSelections: [],
        loading: initialState.loading,
        loader: {
          ...state.loader,
          total: parseInt(action.payload.count, 10)
        }
      }
    case GET_ASSIGNMENTS_FAIL:
      return {
        ...state,
        loading: initialState.loading
      }

    case UPDATE_ASSIGNMENT:
      // set assignments to an empty array so all assignments load when redirected
      return {
        ...state,
        assignments: initialState.assignments
      }
    case UPDATE_ASSIGNMENT_SUCCESS:
      // need to handle this
      return {
        ...state
      }
    case UPDATE_ASSIGNMENT_FAIL:
      // need to handle this
      return {
        ...state
      }

    case UPDATE_BULK_SELECTIONS:
      return {
        ...state,
        bulkSelections: processSelections(state.bulkSelections, action.payload.id)
      }

    case UPDATE_PAGE_SIZE:
      return {
        ...state,
        loader: {
          ...state.loader,
          pageSize: action.payload.count
        }
      }

    case RESET_STATE:
      return {
        ...initialState,
        formId: state.formId,
        sortStatus: initialState.sortStatus
      }
    default:
      return state
  }
}

export function deleteAssignment(formId, versionId, deleteId) {
  const locationId = parseInt(deleteId.split('_')[0], 10)
  const positionId = parseInt(deleteId.split('_')[1], 10)
  const is_uuid = isUUID(formId)
  const versionStr = is_uuid && versionId ? `/version/${versionId}` : ''
  const apiVersion = is_uuid ? 'v2' : 'v1'
  const url =
    `/forms/${formId}` +
    `${versionStr}` +
    '/assignments' +
    `/position/${positionId}` +
    `/location/${locationId}`

  return {
    type: CALL_API,
    types: [DELETE_ASSIGNMENT, DELETE_ASSIGNMENT_SUCCESS, DELETE_ASSIGNMENT_FAIL],
    callAPI: () => axios.delete(url, { ...fetchOptions(apiVersion) }),
    payload: {
      deleteId,
      locationId,
      positionId,
      url,
      apiVersion
    }
  }
}

export function deleteAssignments({ formId, bulkSelections, deleteType, versionId }) {
  const assignments = bulkSelections.reduce((acc, item) => {
    const newObj = {
      locationId: parseInt(item.split('_')[0], 10),
      positionId: parseInt(item.split('_')[1], 10)
    }
    return [...acc, newObj]
  }, [])

  const is_uuid = isUUID(formId)
  const apiVersion = is_uuid && versionId ? 'v2' : 'v1'
  const versionStr = is_uuid && versionId ? `/version/${versionId}` : ''
  const body = { assignments }
  const url = `/forms/${formId}${versionStr}/assignments/remove`

  const finalUrl = deleteType === 'all' ? `${url}?all=true` : url

  const data = deleteType === 'selection' ? JSON.stringify(body) : undefined
  return {
    type: CALL_API,
    types: [DELETE_ASSIGNMENTS, DELETE_ASSIGNMENTS_SUCCESS, DELETE_ASSIGNMENTS_FAIL],
    callAPI: () => axios.post(finalUrl, data, { ...fetchOptions(apiVersion) }),
    payload: {
      deleteItems: bulkSelections,
      deleteType: deleteType
    }
  }
}

export function getAssignments({
  action,
  filter,
  formId,
  pageSize,
  pageNum,
  orderBy,
  ascending,
  searchText,
  totalCount,
  versionId
}) {
  const url = getUrl({
    action,
    ascending,
    filter,
    formId,
    orderBy,
    pageNum,
    pageSize,
    searchText,
    totalCount,
    versionId
  })

  const apiVersion = isUUID(formId) ? 'v2' : 'v1'

  return {
    type: CALL_API,
    types: [GET_ASSIGNMENTS, GET_ASSIGNMENTS_SUCCESS, GET_ASSIGNMENTS_FAIL],
    callAPI: () => axios.get(url, { ...fetchOptions(apiVersion) }),
    payload: {
      action,
      currentPage: pageNum,
      filter,
      formId,
      pageSize,
      searchText,
      sortStatus: {
        ascending: ascending,
        dataKey: orderBy,
        key: getKey(orderBy)
      },
      url
    }
  }
}

export function downloadForCsv({
  action,
  filter,
  formId,
  pageSize,
  pageNum,
  orderBy,
  ascending,
  searchText,
  totalCount,
  versionId
}) {
  const url = getUrl({
    action: 'downloadCsv',
    ascending,
    filter,
    formId,
    orderBy,
    pageNum,
    pageSize,
    searchText,
    totalCount,
    versionId
  })
  const apiVersion = isUUID(formId) ? 'v2' : 'v1'

  return {
    type: CALL_API,
    types: [DOWNLOAD_FOR_CSV, DOWNLOAD_FOR_CSV_SUCCESS, DOWNLOAD_FOR_CSV_FAIL],
    callAPI: () => axios.get(url, { ...fetchOptions(apiVersion) })
  }
}

export function postAssignments({ formId, assignments, versionId }) {
  const is_uuid = isUUID(formId)
  const apiVersion = is_uuid ? 'v2' : 'v1'
  const versionStr = is_uuid && versionId ? `/version/${versionId}` : ''
  return {
    type: CALL_API,
    types: [UPDATE_ASSIGNMENT, UPDATE_ASSIGNMENT_SUCCESS, UPDATE_ASSIGNMENT_FAIL],
    callAPI: () =>
      axios.post(`/forms/${formId}${versionStr}/assignments`, assignments, {
        ...fetchOptions(apiVersion)
      })
  }
}

export function resetState() {
  return {
    type: RESET_STATE
  }
}

export function updateBulkSelections(id = '') {
  return {
    type: id !== 'select_all' ? UPDATE_BULK_SELECTIONS : BULK_SELECT_ALL,
    payload: { id }
  }
}

export function updatePageSize(count) {
  return {
    type: UPDATE_PAGE_SIZE,
    payload: { count }
  }
}

export { sortKeys }



// WEBPACK FOOTER //
// ./src/modules/Forms/reducers/assignments.js